import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import {
  IComponentGroup as IContentfulComponentGroup,
  IHeroWithToggle as IContentfulHeroWithToggle,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  HeroWithToggle,
  IProps as IHeroWithToggle,
} from 'marketing-site/src/library/components/HeroWithToggle'
import { transformGatedContent } from 'marketing-site/src/transformers/components/ContentfulGatedContent'
import { transformWiredCards } from 'marketing-site/src/transformers/components/ContentfulWiredCards'
import { CTA, CTAOrVariationContainer } from 'marketing-site/src/transformers/CTA'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import React from 'react'

export const ContentfulHeroWithToggle = (heroWithToggle: IContentfulHeroWithToggle) => (
  <EntryMarker entry={heroWithToggle}>
    {() => <HeroWithToggle {...transformHeroWithToggle(heroWithToggle)} />}
  </EntryMarker>
)

const cleanSwitchableComponents = (component: IContentfulComponentGroup) => {
  return {
    componentA: component.fields.components[0],
    componentB: component.fields.components[1],
  }
}

export function transformHeroWithToggle({ fields }: IContentfulHeroWithToggle): IHeroWithToggle {
  return {
    ...fields,
    customerImage: transformImage(fields.customerImage),
    customerAnimation: fields.customerAnimation && fields.customerAnimation.fields.file.url,
    customerMobileImage: transformImage(fields.customerMobileImage),
    customerMobileAnimation:
      fields.customerMobileAnimation && fields.customerMobileAnimation.fields.file.url,
    teamsAnimation: fields.teamsAnimation && fields.teamsAnimation.fields.file.url,
    teamsImage: transformImage(fields.teamsImage),
    teamsMobileImage: transformImage(fields.teamsMobileImage),
    teamsMobileAnimation:
      fields.teamsMobileAnimation && fields.teamsMobileAnimation.fields.file.url,
    customerList: fields.customerList && documentToHtmlString(fields.customerList),
    teamList: fields.teamList && documentToHtmlString(fields.teamList),
    wiredCards: transformWiredCards(fields.wiredCards),
    switchableSupportSpotlights: fields.switchableSupportSpotlights.map(cleanSwitchableComponents),
    gatedContent: transformGatedContent(fields.gatedContent),
    renderPrimaryCta: () => <CTAOrVariationContainer {...fields.primaryCta} />,
    renderSecondaryCta: () => fields.secondaryCta && <CTA {...fields.secondaryCta} />,
  }
}
